import React, { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';

import { DataSource } from '@futrli-sdk/organisations';
import { getTimestampRelativeFormat } from '@futrli/localisation';
import {
  isReconnectNeeded,
  isInConnectStart,
  isInSyncing,
  isInSyncFailure,
  isInSyncInitialFailure,
  isInPendingSetup
} from '../../organisations/utils/datasources-status-utils';

export enum INTEGRATION_STATUS_CODES {
  NOT_CONNECTED = 'Not connected',
  CONNECTING = 'Connecting',
  SYNCING = 'Syncing',
  SYNC_ERROR = 'Sync error',
  SYNCED = 'Synced',
  PENDING_SETUP = 'Pending setup'
}

export const useIntegrationStatus = (datasource?: DataSource) => {
  let status: INTEGRATION_STATUS_CODES;
  let statusText: ReactElement;
  let time: ReactElement | undefined;

  if (!datasource) {
    return {};
  }

  if (isReconnectNeeded(datasource)) {
    status = INTEGRATION_STATUS_CODES.NOT_CONNECTED;
    statusText = <FormattedMessage id="common.not_connected" defaultMessage="Not connected" />;
  } else if (isInConnectStart(datasource)) {
    status = INTEGRATION_STATUS_CODES.CONNECTING;
    statusText = <FormattedMessage id="common.connecting" defaultMessage="Connecting" />;
  } else if (isInSyncing(datasource)) {
    status = INTEGRATION_STATUS_CODES.SYNCING;
    statusText = <FormattedMessage id="common.syncing" defaultMessage="Syncing" />;
  } else if (isInSyncFailure(datasource) || isInSyncInitialFailure(datasource)) {
    status = INTEGRATION_STATUS_CODES.SYNC_ERROR;
    statusText = <FormattedMessage id="common.sync_error" defaultMessage="Sync error" />;
    time = getTimestampRelativeFormat(datasource.status.modified, Date.now(), 1);
  } else if (isInPendingSetup(datasource)) {
    status = INTEGRATION_STATUS_CODES.PENDING_SETUP;
    statusText = <FormattedMessage id="common.pending_setup" defaultMessage="Pending setup" />;
  } else {
    status = INTEGRATION_STATUS_CODES.SYNCED;
    statusText = <FormattedMessage id="common.synced" defaultMessage="Synced" />;
    time = getTimestampRelativeFormat(datasource.status.modified, Date.now(), 1);
  }

  return { status, statusText, time };
};
